import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_COMMUNICATION_TEMPLATE, GET_COMMUNICATION_TEMPLATE_SUCCESS, GET_COMMUNICATION_TEMPLATE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCommunicationTemplate({ payload }) {
  
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/message-templates/email_manual_reply`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMMUNICATION_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMMUNICATION_TEMPLATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMMUNICATION_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchGetCommunicationTemplate() {
  yield takeEvery(GET_COMMUNICATION_TEMPLATE, getCommunicationTemplate);
}

function* getCommunicationTemplateSaga() {
  yield all([fork(watchGetCommunicationTemplate)]);
}

export default getCommunicationTemplateSaga;
